import React from "react";
import {
    Box,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; 
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";

const BgConfirmationModal = ({
    isOpen, 
    setIsOpen, 
    moduleType
}: {
    isOpen: boolean; 
    setIsOpen: (open: boolean) => void; 
    moduleType: string | null;
}) => {
    const navigate = useNavigate();
    const handleYesClick = async () => { 
        setIsOpen(false);
        if(moduleType) {
            navigate(`/application-details`);
        } else {
            navigate(`/application-details-row`);
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleYesClick} // ✅ call handleYesClick here too
            maxWidth={false}
            fullWidth={false}
            sx={{
                "& .MuiDialog-paper": {
                    width: "400px",
                    maxWidth: "400px",
                    borderRadius: "8px",
                },
            }}>
            <DialogTitle
                sx={{
                    fontWeight: 600,
                    fontSize: "1.25rem",
                    position: "relative",
                    pb: 1,
                }}>
                electronic Bank Guarantee (e-BG)
                {/* <IconButton
                    aria-label="close"
                    onClick={handleYesClick} // ✅ close via top-right icon
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton> */}
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    borderBottom: "none",
                    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                }}>
                <Box sx={{ display: "flex", justifyContent: "left", mb: 1 }}>
                    <CheckCircleIcon sx={{ fontSize: 64, color: "#43B864" }} />
                </Box>
                <Typography sx={{ fontSize: "1.35rem", fontWeight: 700, mb: 1 }}>
                    electronic Bank Guarantee (e-BG) Submitted Successfully
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    sx={{
                        borderRadius: "24px",
                        backgroundColor: "#3A1C73",
                        textTransform: "none",
                        fontWeight: 500,
                        width: "100%",
                        marginBottom: 1,
                        "&:hover": { backgroundColor: "#2a145c" },
                    }}
                    onClick={handleYesClick}
                >
                    OK, Got it.
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BgConfirmationModal;
